import s from './Header.module.scss';
import React, {useEffect, useRef, useState} from 'react';
import logo from '../../assets/images/header.png';
import {useLocation, useNavigate} from 'react-router-dom';
import WeatherWidget from "./WeatherWidget";
import {getWishlist} from '../../components/wishList/wishlist';
import api from "../../api/client";
import {OPEN_TOUR_SEARCH} from "./tourSearch";

const Header = () => {
    const location = useLocation();
    const [cartCount, setCartCount] = useState(0);
    const [wishlistCount, setWishlistCount] = useState(0);


    const [searchTags, setSearchTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [searchTagsLoading, setSearchTagsLoading] = useState(false);
    const [desktopSearchOpen, setDesktopSearchOpen] = useState(false);
    const [desktopSearchTagsOpen, setDesktopSearchTagsOpen] = useState(false);
    const [desktopSearchClosing, setDesktopSearchClosing] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const searchCloseTimer = useRef(null);
    useEffect(() => {

        if (!desktopSearchOpen && !searchOpen) {
            return;
        }

        const fetchSearchTags = async () => {

            try {

                setSearchTagsLoading(true);

                const response = await api.get('/api/tags');

                setSearchTags(response.data || []);

            } catch (error) {

                console.error(
                    'Failed to load search tags',
                    error
                );

            } finally {

                setSearchTagsLoading(false);

            }
        };

        fetchSearchTags();

    }, [desktopSearchOpen, searchOpen]);

    useEffect(() => {
        const updateCartCount = () => {
            const cart = JSON.parse(
                localStorage.getItem('booking_cart') || '[]'
            );

            setCartCount(cart.length);
        };

        // initial load
        updateCartCount();

        // update from other browser tabs
        window.addEventListener(
            'storage',
            updateCartCount
        );

        // update in same tab
        window.addEventListener(
            'cartUpdated',
            updateCartCount
        );

        return () => {
            window.removeEventListener(
                'storage',
                updateCartCount
            );

            window.removeEventListener(
                'cartUpdated',
                updateCartCount
            );
        };
    }, []);
    useEffect(() => {
        const updateCounts = () => {
            const cart = JSON.parse(
                localStorage.getItem('booking_cart') || '[]'
            );

            setCartCount(cart.length);

            const wishlist = getWishlist();

            setWishlistCount(wishlist.length);
        };

        // Initial load
        updateCounts();

        // Other browser tabs
        window.addEventListener('storage', updateCounts);

        // Same tab - cart
        window.addEventListener('cartUpdated', updateCounts);

        // Same tab - wishlist
        window.addEventListener('wishlistChanged', updateCounts);

        return () => {
            window.removeEventListener('storage', updateCounts);
            window.removeEventListener('cartUpdated', updateCounts);
            window.removeEventListener('wishlistChanged', updateCounts);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(location.search);

        setKeyword(params.get("kw") || "");
    }, [location.search]);
    useEffect(() => {

        return () => {
            clearTimeout(searchCloseTimer.current);
        };

    }, []);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const [keyword, setKeyword] = useState("");

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };
    const openDesktopSearch = () => {

        clearTimeout(searchCloseTimer.current);

        setDesktopSearchClosing(false);
        setDesktopSearchOpen(true);
        setDesktopSearchTagsOpen(true);

    };

    useEffect(() => {
        const handleOpenTourSearch = () => {
            setMenuOpen(false);
            clearTimeout(searchCloseTimer.current);
            setDesktopSearchClosing(false);

            if (window.matchMedia('(max-width: 991px)').matches) {
                setDesktopSearchOpen(false);
                setDesktopSearchTagsOpen(false);
                setSearchOpen(true);
            } else {
                setSearchOpen(false);
                setDesktopSearchOpen(true);
                setDesktopSearchTagsOpen(true);
            }
        };

        window.addEventListener(OPEN_TOUR_SEARCH, handleOpenTourSearch);
        return () => window.removeEventListener(OPEN_TOUR_SEARCH, handleOpenTourSearch);
    }, []);

    const closeDesktopSearch = () => {

        setDesktopSearchClosing(true);
        setDesktopSearchTagsOpen(false);

        clearTimeout(searchCloseTimer.current);

        searchCloseTimer.current = setTimeout(() => {

            setDesktopSearchOpen(false);
            setDesktopSearchClosing(false);

        }, 300);

    };
    const toggleSearchTag = (tag) => {

        const tagId = tag.name;

        setSelectedTags(prev => {

            const exists = prev.some(
                selected => selected.name === tagId
            );

            if (exists) {

                return prev.filter(
                    selected => selected.name !== tagId
                );

            }

            return [...prev, tag];

        });

    };
    const handleDesktopSearchSubmit = () => {

        const params = new URLSearchParams();

        if (keyword.trim()) {
            params.set('kw', keyword.trim());
        }

        if (selectedTags.length > 0) {

            params.set(
                'tags',
                selectedTags
                    .map(tag => tag.name)
                    .join(',')
            );

        }

        params.set('page', '1');

        setDesktopSearchTagsOpen(false);
        setDesktopSearchOpen(false);

        navigate({
            pathname: '/all-tours',
            search: params.toString()
        });

    };
    const handleMobileSearchSubmit = () => {

        const params = new URLSearchParams();

        if (keyword.trim()) {

            params.set(
                'kw',
                keyword.trim()
            );

        }

        if (selectedTags.length > 0) {

            params.set(
                'tags',
                selectedTags
                    .map(tag => tag.name)
                    .join(',')
            );

        }

        params.set('page', '1');

        setSearchOpen(false);

        navigate({
            pathname: '/all-tours',
            search: params.toString()
        });

    };
    const handleLogoClick = () => {
        navigate('/');
    };
    const handleSearchToggle = () => {
        setSearchOpen(prev => !prev);
    };

    const handleSearch = (e) => {
        if (e.key === "Enter") {
            updateSearchParam(keyword);
        }
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const handleSearchSubmit = () => {
        if (!keyword.trim()) updateSearchParam(keyword);
        ;
        updateSearchParam(keyword);
    };
    const updateSearchParam = (value) => {
        setMenuOpen(false); // close navbar menu
        const params = new URLSearchParams(window.location.search);

        if (value && value.trim()) {
            params.set("kw", value);
            params.set("page", 1);
        } else {
            params.delete("kw"); // ✅ remove
            params.set("page", 1);
        }

        navigate({
            pathname: "/all-tours",
            search: params.toString()
        });
    };
    const clearAllSearchTags = () => {
        setSelectedTags([]);
    };

    return (
        <>
            <nav className={`${s.navbar} navbar navbar-expand-lg ${s.navBgColor}`}>
                <div className="container-fluid">

                    {/* LOGO */}
                    <button
                        className="navbar-brand border-0 bg-transparent"
                        onClick={handleLogoClick}
                    >
                        <img className={s.logo} src={logo} alt="ジェイさんツアーロゴ"/>
                    </button>
                    <div className="d-lg-none d-flex align-items-center ms-auto">
                        <div className={`${s.searchContainer} ${s.searchContainerBtn}`}>
                            <button
                                className={s.searchIcon}
                                onClick={() => {

                                    setSearchOpen(true);

                                    if (menuOpen) {
                                        setMenuOpen(false);
                                    }

                                }}
                                aria-label="Search"
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                        <div
                            className={`${s.cartButton} me-2`}
                            onClick={() => navigate('/wishlist')}
                        >
                            <i className="fa-regular fa-heart"></i>

                            {wishlistCount > 0 && (
                                <span className={s.cartBadge}>
            {wishlistCount}
        </span>
                            )}
                        </div>
                        <div
                            className={`${s.cartButton} me-2`}
                            onClick={() => navigate('/cart')}
                        >
                            <i className="fa fa-cart-shopping"></i>

                            {cartCount > 0 && (
                                <span className={s.cartBadge}>
                {cartCount}
            </span>
                            )}
                        </div>

                        {/* MOBILE TOGGLE */}
                        <button
                            className={`navbar-toggler  ${s.navbarToggler}`}
                            type="button"

                            onClick={toggleMenu}
                        >
                            {menuOpen ? (
                                <i className="fa-solid fa-xmark"></i>
                            ) : (
                                <span className="navbar-toggler-icon"></span>
                            )}
                        </button>
                    </div>
                    {/* MENU */}
                    <div
                        className={`collapse navbar-collapse ${menuOpen ? `show  ${s.mobileMenu}` : ''} ${searchOpen && !isMobile ? s.hideMenu : ''}`}>

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                            <li className="nav-item">
                                <button className="nav-link active btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/')
                                }}>
                                    ホーム
                                </button>
                            </li>

                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/all-tours')
                                }}>
                                    ツアー
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/lowest-price-guarantee')
                                }}>
                                    低価格保証
                                </button>
                            </li>

                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/howto')
                                }}>
                                    予約手続き
                                </button>
                            </li>

                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/contact')
                                }}>
                                    現地オフィス
                                </button>
                            </li>

                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/faqs')
                                }}>
                                    よくある質問
                                </button>
                            </li>

                            <li className="nav-item">
                                <button className="nav-link btn btn-link" onClick={() => {
                                    toggleMenu()
                                    navigate('/special-offers')
                                }}>
                                    特別オファー
                                </button>
                            </li>

                        </ul>

                        {/* RIGHT SIDE */}
                        <div className={`d-flex align-items-center gap-3   ${s.menuFooter}`}>


                            <div className={`${s.desktopSearch} order-0 order-md-0`}>

                                {!desktopSearchOpen && (
                                    <button
                                        className={s.searchIcon}
                                        onClick={openDesktopSearch}
                                    >
                                        <i className="fa fa-search"></i>
                                    </button>
                                )}

                                {desktopSearchOpen && (

                                    <div
                                        className={`${s.desktopSearchWrapper} ${
                                            desktopSearchClosing
                                                ? s.desktopSearchClosing
                                                : s.desktopSearchOpening
                                        }`}
                                    >

                                        {/* SEARCH INPUT */}

                                        <div className={s.desktopSearchBox}>

                                            <input
                                                autoFocus
                                                type="text"
                                                value={keyword}
                                                placeholder="ツアーを検索"
                                                onChange={(e) => setKeyword(e.target.value)}
                                                onFocus={() => setDesktopSearchTagsOpen(true)}
                                                onKeyDown={(e) => {

                                                    if (e.key === 'Enter') {
                                                        handleDesktopSearchSubmit();
                                                    }

                                                    if (e.key === 'Escape') {
                                                        closeDesktopSearch();
                                                    }

                                                }}
                                            />

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setKeyword('');
                                                    closeDesktopSearch();
                                                }}
                                                aria-label="Close search"
                                            >
                                                <i className="fa fa-xmark"></i>
                                            </button>


                                        </div>


                                        {/* TAG DROPDOWN */}

                                        {desktopSearchTagsOpen && (

                                            <div className={s.searchTagDropdown}>

                                                <div className={s.searchTagHeader}>

    <span>
        ツアーを絞り込む
    </span>

                                                    {selectedTags.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className={s.clearAllButton}
                                                            onClick={clearAllSearchTags}
                                                        >
                                                            すべてクリア
                                                        </button>
                                                    )}

                                                </div>


                                                <div className={s.searchTagList}>

                                                    {searchTagsLoading && (

                                                        <div className={s.searchTagLoading}>
                                                            読み込み中...
                                                        </div>

                                                    )}


                                                    {!searchTagsLoading &&
                                                        searchTags.map(tag => {

                                                            const selected =
                                                                selectedTags.some(
                                                                    selectedTag =>
                                                                        selectedTag.id === tag.id
                                                                );

                                                            return (

                                                                <button
                                                                    type="button"
                                                                    key={tag.id}
                                                                    className={`${s.searchTag} ${
                                                                        selected
                                                                            ? s.searchTagSelected
                                                                            : ''
                                                                    }`}
                                                                    onClick={() =>
                                                                        toggleSearchTag(tag)
                                                                    }
                                                                >
                                                                    {selected && (
                                                                        <i className="fa fa-check"></i>
                                                                    )}
                                                                    <span>
                                            {tag.name}
                                        </span>


                                                                </button>

                                                            );

                                                        })}

                                                </div>


                                                {/* FOOTER */}

                                                <div className={s.searchDropdownFooter}>

                                                    <div className={s.searchSummary}>

                                                        {selectedTags.length > 0 ? (

                                                            <>
                                                                <strong>
                                                                    {selectedTags.length}
                                                                </strong>

                                                                <span>
                                        件のタグを選択中
                                    </span>
                                                            </>

                                                        ) : (

                                                            <span>
                                    タグを選択してください
                                </span>

                                                        )}

                                                    </div>


                                                    <button
                                                        type="button"
                                                        className={s.searchEnterButton}
                                                        onClick={handleDesktopSearchSubmit}
                                                    >
                                                        検索
                                                        <i className="fa fa-arrow-right"></i>
                                                    </button>

                                                </div>

                                            </div>

                                        )}

                                    </div>

                                )}

                            </div>
                            {/*)}*/}
                            <div
                                className={`${s.cartButton} ${s.desktopWishlist}`}
                                onClick={() => navigate('/wishlist')}
                            >
                                <i className="fa-regular fa-heart"></i>

                                {wishlistCount > 0 && (
                                    <span className={s.cartBadge}>
            {wishlistCount}
        </span>
                                )}
                            </div>
                            <div
                                className={` ${s.cartButton} ${s.desktopCart}  order-3 order-md-2`}
                                onClick={() => navigate('/cart')}
                            >
                                <i className="fa fa-cart-shopping"></i>

                                {cartCount > 0 && (
                                    <span className={s.cartBadge}>
                                    {cartCount}
                                </span>
                                )}
                            </div>
                            {/* Hide weather ONLY on desktop search open */}
                            <div className="order-1 order-md-3">
                                {<WeatherWidget/>}
                            </div>


                        </div>

                    </div>
                </div>


            </nav>
            {/* =========================================================
    MOBILE SEARCH OVERLAY
========================================================= */}

            <div
                className={`${s.mobileSearchOverlay} ${
                    searchOpen ? s.mobileSearchOverlayOpen : ''
                }`}
            >

                {/* =====================================================
        MOBILE SEARCH HEADER
    ===================================================== */}

                <div className={s.mobileSearchTopHeader}>

                    <div className={s.mobileSearchHeaderTitle}>
                        <i className="fa fa-search"></i>

                        <span>
                検索
            </span>
                    </div>

                    <button
                        type="button"
                        className={s.mobileSearchClose}
                        onClick={() => setSearchOpen(false)}
                        aria-label="Close search"
                    >
                        <i className="fa fa-xmark"></i>
                    </button>

                </div>


                {/* =====================================================
        CONTENT
    ===================================================== */}

                <div className={s.mobileSearchContent}>

                    {/* SEARCH INPUT */}

                    <div className={s.mobileSearchBox}>

                        <i className="fa fa-search"></i>

                        <input
                            autoFocus={searchOpen}
                            type="text"
                            value={keyword}
                            placeholder="ツアーを検索"
                            onChange={(e) =>
                                setKeyword(e.target.value)
                            }
                            onKeyDown={(e) => {

                                if (e.key === 'Enter') {
                                    handleMobileSearchSubmit();
                                }

                            }}
                        />

                        {keyword && (

                            <button
                                type="button"
                                className={s.mobileClearButton}
                                onClick={() => setKeyword('')}
                                aria-label="Clear search"
                            >
                                <i className="fa fa-xmark"></i>
                            </button>

                        )}

                    </div>


                    {/* =================================================
            TAG HEADER
        ================================================= */}

                    <div className={s.mobileSearchTitle}>

            <span>
                ツアーを絞り込む
            </span>

                        {selectedTags.length > 0 && (

                            <button
                                type="button"
                                className={s.clearAllButton}
                                onClick={clearAllSearchTags}
                            >
                                すべてクリア
                            </button>

                        )}

                    </div>


                    {/* =================================================
            TAGS
        ================================================= */}

                    <div className={s.mobileTagList}>

                        {searchTagsLoading && (

                            <div className={s.searchTagLoading}>
                                読み込み中...
                            </div>

                        )}


                        {!searchTagsLoading &&
                            searchTags.map(tag => {

                                const selected =
                                    selectedTags.some(
                                        selectedTag =>
                                            selectedTag.id === tag.id
                                    );

                                return (

                                    <button
                                        type="button"
                                        key={tag.id}
                                        className={`${s.mobileTag} ${
                                            selected
                                                ? s.mobileTagSelected
                                                : ''
                                        }`}
                                        onClick={() =>
                                            toggleSearchTag(tag)
                                        }
                                    >

                                        {selected && (
                                            <i className="fa fa-check"></i>
                                        )}

                                        <span>
                                {tag.name}
                            </span>

                                    </button>

                                );

                            })}

                    </div>

                </div>


                {/* =====================================================
        FOOTER
    ===================================================== */}

                <div className={s.mobileSearchFooter}>

                    <div className={s.mobileSearchSummary}>

                        {selectedTags.length > 0 ? (

                            <>
                                <strong>
                                    {selectedTags.length}
                                </strong>

                                <span>
                        件のタグを選択中
                    </span>
                            </>

                        ) : (

                            <span>
                    キーワードまたはタグを選択してください
                </span>

                        )}

                    </div>


                    <button
                        type="button"
                        className={s.mobileSearchSubmit}
                        onClick={handleMobileSearchSubmit}
                    >
                        検索
                        <i className="fa fa-arrow-right"></i>
                    </button>

                </div>

            </div>

        </>
    );
};

export default Header;
